import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import logoutAnimation from '../assets/animation/ecg-animation6.json';

const LogoutPage: React.FC = () => {
  const navigate = useNavigate();
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(2);
    }
    const timer = setTimeout(() => {
      navigate('/'); 
    }, 9000);

    return () => clearTimeout(timer); 
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-full bg-[#eaeaea]">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
  </div>
  );
};

export default LogoutPage;
